<template>
  <div class="c-2025">
    <Intro />
    <Banner :max="max" />
    <section
      id="c-2025-services"
      class="section text-left services"
    >
      <b-container class="mb-0">
        <b-row class="topics-row">
          <b-col
            v-for="(topic, index) in ['date', 'space', 'toolbox', 'pdf', 'petitions', 'count']"
            :key="index"
            class="topics-wrapper"
            lg="6"
          >
            <Topic
              :index="index"
              :title="$t(`c2025.topics.${topic}.title`)"
              :description="$t(`c2025.topics.${topic}.description`)"
              :thumbnail-image-url="$t(`c2025.topics.${topic}.thumbnailImageUrl`)"
              :icon-image-url="$t(`c2025.topics.${topic}.iconImageUrl`)"
              :service-link-url="$t(`c2025.topics.${topic}.serviceLinkUrl`)"
              :presentation-link-url="$t(`c2025.topics.${topic}.presentationLinkUrl`)"
              :publication-date="$t(`c2025.topics.${topic}.publicationDate`)"
            />
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="section text-left pt-4 mb-4 peertube">
      <div class="background all-width-absolute">
        <div class="background-left"></div>
        <div class="background-right"></div>
      </div>
      <b-container class="mb-0">
        <PeerTube />
      </b-container>
    </section>

    <section class="section quote">
      <b-container class="mb-0">
        <b-row>
          <b-col>
            <blockquote class="blockquote text-right">
              <span v-html="$t('c2025.why.list[0]')"></span>
              <footer class="text-center">
                <a
                  target="_blank"
                  rel="noopener"
                  class="btn btn-lg btn-primary"
                  :href="$t('c2025.why.link')"
                  v-html="$t('c2025.why.blog')"
                ></a>
              </footer>
            </blockquote>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script setup>
import Topic from './campaign/2025/Topic.vue';
import Intro from './campaign/2025/Intro.vue';
import Banner from './campaign/2025/Banner.vue';
import PeerTube from './campaign/2025/PeerTube.vue';

const max = 300000; // campaign target
const endCampaign = new Date('2026-01-01T23:59:59');

</script>

<style lang="scss">
.c-2025 {

  background: #fff url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='600' viewBox='0 0 100 100'%3E%3Cpath d='M5.5 12a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM6 46a2 2 0 10.001-3.999A2 2 0 006 46zM31.5 8a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-3 30a2 2 0 10.001-3.999A2 2 0 0028.5 38zm16-10a2.5 2.5 0 000-5 2.5 2.5 0 000 5zM40 17.5a1 1 0 100-2 1 1 0 000 2zm-10 31a1 1 0 100-2 1 1 0 000 2zm-12.5-25a1 1 0 100-2 1 1 0 000 2zm60.03 1.242a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-21.5-3.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm31.5 15.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-22.5 11.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm28-38a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-25 3.5a2 2 0 100-4 2 2 0 000 4zm23 35.5a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-37-16a1 1 0 100-2 1 1 0 000 2zM29.5 74a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM8 70.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM39.5 86a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM17 97.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm28-38a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20 63a2 2 0 10.001-3.999A2 2 0 0020 63zm23 35.5a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-37-16a1 1 0 100-2 1 1 0 000 2zm71.53-8.258a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-12.5 23.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm14.5-40a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-3 30a2 2 0 100-4 2 2 0 000 4zm14.5 11a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm1.5-21a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-4.5-10.5a1 1 0 100-2 1 1 0 000 2zm-34 15.5a1 1 0 100-2 1 1 0 000 2z' fill='%23e2e8f0' fill-opacity='.3'/%3E%3C/svg%3E");

  .topics-wrapper {
    margin: 1rem auto 4rem auto;
  }

  .topic img {
    +img {
      position: absolute;
      top: calc(50% - 25%);
      left: calc(50% - 12.5%);
      width: 25%;
    }
  }

  #progress-banner-2025 {
    display: block;
    order: 6;
    overflow: hidden;
    position: relative;
    width: 100%;
    margin: 1rem auto 4rem;

    .banner {
      border: 5px solid var(--f-g7);
      border-left: none;
      border-right: none;
      position: relative;
      height: 240px;
      width: 100%;

      @media (min-width: 768px) {
        height: 420px;
      }
    }

    .active,
    .inactive {
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;

      div {
        width: 100vw;
        height: 100%;
        background-image: url('../../public/img/campaign/2025/banner.jpg');
        background-size: cover;
        background-position: right;
      }
    }

    .inactive {
      filter: grayscale(.85);
    }

    .active {
      border-right: 2px solid var(--f-g7);
      box-shadow: 4px 0px 15px rgba(0, 0, 0, 0.7);
      transition: width .1s linear;
      z-index: 1;
    }

    .animate {
      transition: width 1s ease-in-out;
    }
  }

  .peertube {
    position: relative;
    min-height: 320px;

    & > .background {
      border: 1px solid #FFB370;
      background: #f2690d;
      position: absolute;
      z-index: 1;
      height: 100%;
      left: -1rem;
      right: -1rem;

      .background-left {
          height: 100%;
          background: url('../../public/img/campaign/2025/pt/peertube-logo-background.svg');
          min-height: 320px;
          width: 49.8%;
          display: inline-block;
      }

      .background-right {
          height: 100%;
          background: url('../../public/img/campaign/2025/pt/peertube-logo-background.svg');
          min-height: 320px;
          width: 49%;
          display: inline-block;
          transform: rotate(180deg);
      }
    }

    & > .container {
      position: relative;
    }
  }

  .services {
    padding: 1rem 0 5rem;
  }

  .quote {
    padding: 3rem 0;
    background: unset;

    .blockquote footer a {
      margin-top: 2rem;
    }
  }
}
</style>
